import React, { useState, useEffect, useRef } from 'react';
import Layout from '../Layouts/mainLayout';
import HeaderIndex from '../components/headerIndex';
import StyledFlickity from '../components/styledFlickity';
import api from '../components/setAxios';
import config, { formaturl } from '../config/staticData';
import { Link } from 'react-router-dom';


const Home = () => {

   //this part use for video part
  //------------------------------------------------------------------
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedId, setselectedId] = useState(0);
    const [videoBlogs, setVideoBlogs] = useState([]);
    const [podcastBlogs, setPodcastBlogs] = useState([]);
    const [isContentVisible, setIsContentVisible] = useState(true);
    const videoRef = useRef(null);

    const playVideo = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsContentVisible(false);
        }
    };

    useEffect(() => {
        Load();
    }, []);

    useEffect(() => {
        if (videoBlogs.length > 0) {
            setSelectedItem(videoBlogs[0]);
        }
    }, [videoBlogs]); 

    async function Load() {
        const videoResult = await api.get("/blog/GetVideoBlogs/video");
        const podResult = await api.get("/blog/GetVideoBlogs/Podcast");
        setVideoBlogs(videoResult.data);
        setPodcastBlogs(podResult.data);
    }

    const handleClick = (item, index) => {
      setSelectedItem(item);
      setselectedId(index);
      setIsContentVisible(true);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
        videoRef.current.load();
      }
    };

    function VideoLi({ data, onClick,loopNumber }) {
    var className='video-item';
    if(selectedId==0 && loopNumber==1) className="video-item active";
    else if(selectedId===loopNumber) className="video-item active";

    return (
      <li className={className} onClick={onClick} >
        <div className='video-item-img'>
         <img src={`${config.videoPath}${data.blogCovver}`} alt={`Video titled ${data.title}`} />
        </div>
        <div className='video-item-info'>
          <div className='txt'>{data.title}</div>
          <div className='time'>
            <i className="fas fa-clock"></i>
            <span>{data.publishDate}</span>
            <Link className='video-detail-link' to={`${process.env.REACT_APP_BASE_PATH}/${data.id}/${formaturl(data.title)}`} state={{ blogId: data.id }} >...</Link>
          </div>
        </div>
      </li>
    );
  }
//------------------------------------------------------------------
  
//Tab Part
//------------------------------------------------------------------
  const flickityVideoOptions = {
    pageDots:false,
    prevNextButtons: false,
    contain: true,
    rightToLeft: true,
    bgLazyLoad: 1,
    selectedAttraction: 0.01,
    friction: 0.15
  };
  const Video=()=>{
      const flickityVideoContent = videoBlogs.map((item, index) => {
          return (
              <li key={index } className="carousel-video-cell">
                <div className='card-side' >
                    <img src={`${config.videoPath}${item.blogCovver}`} alt={`Video titled ${item.title}`} />
                    <div className='card-info'>
                        <div className='txt'>{item.title}</div>
                        <div className='card-footer'>
                            <i className="fas fa-clock"></i>
                            <span>{item.publishDate}</span>
                            <Link to={`${process.env.REACT_APP_BASE_PATH}/${item.id}/${formaturl(item.title)}`} state={{ blogId: item.id }} >...</Link>
                        </div>
                    </div>
                </div>
              </li>
      );
    });
    return(
      <StyledFlickity flickityOptions={flickityVideoOptions} flickityStyle={'carousel-video'} flickityContent={flickityVideoContent} />      
    )
  }

  const PodCast=()=>{
      const flickityPodcastContent = podcastBlogs.map((item, index) => {
      return (
          <li key={index} className="carousel-video-cell">
              <div className='card-side' >
                  <img src={`${config.podcastPath}${item.blogCovver}`} alt={`Video titled ${item.title}`} />
                  <div className='card-info'>
                      <div className='txt'>{item.title}</div>
                      <div className='card-footer'>
                          <i className="fas fa-clock"></i>
                          <span>{item.publishDate}</span>
                          <a href="#">...</a>
                      </div>
                  </div>
              </div>
          </li>
      );
    });
    return(
      <StyledFlickity flickityOptions={flickityVideoOptions} flickityStyle={'carousel-video'} flickityContent={flickityPodcastContent} />      
    )
  }

  const Tabs=({config})=>{
    const [activeTab,setActiveTab]=useState(0);
    return(
      <div className="tab" >
        <div className="tab-headers" >
          {
            config.map((entry,index)=>(
              <div key={index}
                className={`tab-header ${activeTab===index?"current":""}`}
                onClick={()=>setActiveTab(index)}
              >
                {entry.header}
              </div>
            ))
          }
        </div>
        <div className='tab-body' >
            {config[activeTab].component}
        </div>
      </div>
    )
  }
  //---------------------------------------------------------------

  return (
    <>
    <Layout header={HeaderIndex}>
      <section className='videoPart'>
        <div className="part-title video">
          <h3>
            جدیدترین ویدئوها
          </h3>
          <div className="sep"></div>
        </div>
        <div className='video-parts'>
          <div className='video-list'>
            <ul>
                {videoBlogs.map((item,index) => {
                return (
                  <VideoLi
                    key={index}
                    onClick={() => handleClick(item, index)}
                    data={item}
                    isSelected={selectedItem && ++index === selectedItem.id}
                    loopNumber={index}
                  />
                );
              })}
            </ul>
          </div>
          <div className='video-details'>
          {selectedItem && (
            <>
                {isContentVisible && (
                    <div>
                        <img src={`${config.videoPath}${selectedItem.blogCovver}`} alt={selectedItem.title} />
                        <button className="video-btn" onClick={playVideo}>
                            <i className="fa-solid fa-play"></i>
                        </button>
                    </div>
                )}
                <video ref={videoRef} controls style={{ display: isContentVisible ? 'none' : 'block' }}>
                    <source src={`${config.videoPath}${selectedItem.blogVideo}`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                              <div className='title'>
                                  <a href="#">{selectedItem.title}</a>
                              </div>
                              <div className='sep'></div>
                              <div className='description'>
                                  <span>{selectedItem.summary}</span>
                                  <Link to={`${process.env.REACT_APP_BASE_PATH}/${selectedItem.id}/${formaturl(selectedItem.title)}`} state={{ blogId: selectedItem.id }} > بیشتر بخوانید</Link>
                              </div>
                              <div className='info'>
                <div className="author">
                  <div className="custom-author-background user-profile-stat-wrapper">
                    <span className="author_name">
                    <a href="#" title={selectedItem.fullName} rel="author">{selectedItem.fullName}</a>
                    </span>
                  </div>
                  <i className="fas fa-clock" />
                  <span className="author_time">{selectedItem.publishDate}</span>
                </div>
                <div className="popularity">
                  <div className="popularity-comments">
                    <i className="fas fa-comment" />
                      <span className="popularity-comments-num">۰</span>
                  </div>
                </div>
              </div>
            </>
          )}

          </div>
        </div>
      </section>

      <section className='video-mobile'>
        <Tabs 
         config={[
          {header:"جدیدترین ویدیوها",component:<Video />},
          {header:"جدیدترین پادکست ها",component:<PodCast />}
         ]}
        />
      </section>
    </Layout>
    </>
    
  );
};

export default Home;